import { render, staticRenderFns } from "./VTour.vue?vue&type=template&id=e50d129c&"
import script from "./VTour.vue?vue&type=script&lang=js&"
export * from "./VTour.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports